export default {
    ListLoading: 'index:index:ListLoading', // 流加载
    INDEXLIST: 'index:index:indexList', // 获取列表
};



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/exportData/constant.js